 import initialState from './initialState';
import {
  APP_INIT,
  APP_SET_ERROR,
  APP_SET_READY,
  APP_SET_PROVISIONS,
  APP_SET_SETTINGS,
} from '../constants/actionTypes';

export default function (state = initialState.app, { type, payload }) {
  switch (type) {
    case APP_SET_SETTINGS:
      return Object.assign({}, state, payload);

    case APP_SET_PROVISIONS:
      return Object.assign({}, state, { provisions: payload.provisions} );
    case APP_INIT:      
    case APP_SET_READY:      
    case APP_SET_ERROR:    
    default:
      return state;
  }
}
